import { render } from "./Captingv2.vue?vue&type=template&id=362e7bc2&scoped=true"
import script from "./Captingv2.vue?vue&type=script&lang=js"
export * from "./Captingv2.vue?vue&type=script&lang=js"

import "./Captingv2.vue?vue&type=style&index=0&id=362e7bc2&scoped=true&lang=css"

import exportComponent from "G:\\01.Progetti\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362e7bc2"]])

export default __exports__